// Import from addon directly so we break circular dependencies
import { Input } from '@frontile/forms';
import { or } from '../../utilities.ts';
import { tracked } from '@glimmer/tracking';
import { debounce } from '@ember/runloop';
import Component from '@glimmer/component';
import type Owner from '@ember/owner';
import { PhMagnifyingGlass } from 'ember-phosphor-icons';

const DELAY = 300;

interface SearchInputSignature {
  Args: {
    ariaLabel?: string;
    onInput: (value: string) => void;
    onSubmit: (value: string) => void;
    placeholder?: string;
    searchString: string;
    label?: string;
  };
  Element: HTMLInputElement;
}

export default class SearchInputComponent extends Component<SearchInputSignature> {
  @tracked userInput = '';

  constructor(owner: Owner, args: SearchInputSignature['Args']) {
    super(owner, args);
    if (this.args.searchString) {
      this.userInput = this.args.searchString;
    }
  }

  clearInput = () => {
    this.userInput = '';
    this.args.onInput?.('');
  };

  didInput = (value: string) => {
    this.userInput = value;

    debounce(this, this.args.onInput, value, DELAY);
  };

  <template>
    <Input
      @isClearable={{true}}
      @onInput={{this.didInput}}
      @onChange={{@onSubmit}}
      @type="text"
      @value={{this.userInput}}
      @label={{@label}}
      aria-label={{or @ariaLabel "Search"}}
      autocomplete="off"
      class="ps-10 pe-10"
      name="search-input"
      placeholder={{@placeholder}}
      ...attributes
    >
      <:startContent>
        <PhMagnifyingGlass @size="16" />
      </:startContent>
    </Input>
  </template>
}
